<script>
    import VTextField from 'vuetify/es5/components/VTextField/VTextField'

    export default VTextField.extend({
        name: 'input-field',
        extends: VTextField,
        props: {
            outlined: { type: Boolean, default: true}
        }
    })

</script>
